import './title.css'
import RedIcon from "../icons/red/red";
import ShareIcon from "../icons/share/share";
import InstagramIcon from "../icons/Instagram/instagram";
import MenuIcon from "../icons/menu/menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useWhiteLabel } from "../../whiteLabel/useWhiteLabel";
import { shouldHideInstagramRedIcons } from "./indexIconsConfig";

function PageTitle(props) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isWhiteLabel } = useWhiteLabel();
    const hideInstagramRed = !isWhiteLabel && shouldHideInstagramRedIcons(pathname);

    return (<>
        <header className={`index-title${isWhiteLabel ? " index-title--white-label" : ""}`}>
            <div className={"index-icons"}>
                {!isWhiteLabel && <>
                    {!hideInstagramRed && <InstagramIcon/>}
                    {!hideInstagramRed && <RedIcon/>}
                    <ShareIcon/>
                </>}
                <MenuIcon/>
            </div>

            {!isWhiteLabel && <>
                <div onClick={()=>{
                    navigate("/")
                }} className={"index-h1"}>
                    <span>H E I</span>
                    <span>C R E A T I V E</span>
                </div>
                <p>PHOTOGRAPHY | CREATOR PARTNERSHIPS</p>
                {/*<p>Based in London</p>*/}
            </>}

            {props.children}
        </header>

    </>)
}

export default PageTitle
